/** GET /api/rbac/context response shape */
export interface RbacContext {
  superAdmin: boolean;
  /**
   * Returned by BE for Customer_Admin and similar roles.
   * Never used for UI/route gating — permissions[] is authoritative when superAdmin is false.
   */
  fullAccess: boolean;
  permissions: string[];
  roleNames: string[];
  administeredCustomerIds: Array<number | string>;
}

export const EMPTY_RBAC_CONTEXT: RbacContext = {
  superAdmin: false,
  fullAccess: false,
  permissions: [],
  roleNames: [],
  administeredCustomerIds: [],
};
